// window.summarySharing = function () {
//     return {
//         transactions: [],
//         totalPiutang: 0,
//         lastUpdate: '',
//         activeId: null,

//         async init() {
//             await this.fetchData();
//             this.lastUpdate = new Date().toLocaleString('id-ID', {
//                 day: '2-digit',
//                 month: 'short',
//                 year: 'numeric',
//                 hour: '2-digit',
//                 minute: '2-digit'
//             });
//         },

//         async fetchData() {
//             try {
//                 // Pastikan axios sudah terinstall/tersedia secara global
//                 const response = await axios.get('/pelaporan/get-summary-announcement');
//                 this.transactions = response.data ?? [];

//                 this.totalPiutang = this.transactions.reduce(
//                     (acc, curr) => acc + Number(curr.sisa_tagihan || 0),
//                     0
//                 );
//             } catch (e) {
//                 console.error("Fetch summary error", e);
//                 this.transactions = [];
//             }
//         },

//         toggleDetail(id) {
//             this.activeId = this.activeId === id ? null : id;
//         },

//         formatRupiah(n) {
//             return new Intl.NumberFormat('id-ID', {
//                 style: 'currency',
//                 currency: 'IDR',
//                 minimumFractionDigits: 0
//             }).format(n ?? 0);
//         },

//         getInitials(name) {
//             if (!name) return '??';
//             return name
//                 .split(' ')
//                 .filter(v => v)
//                 .map(n => n[0])
//                 .join('')
//                 .toUpperCase()
//                 .substring(0, 2);
//         }
//     }
// }

window.summarySharing = function () {
    return {
        transactions: [],
        totalPiutang: 0,
        lastUpdate: '',
        activeId: null,

        search: '', // keyword search

        async init() {
            await this.fetchData();
            this.lastUpdate = new Date().toLocaleString('id-ID', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        },

        async fetchData() {
            try {
                const response = await axios.get('/pelaporan/get-summary-announcement');
                this.transactions = response.data ?? [];

                this.calculateTotal(); // pakai function terpisah
            } catch (e) {
                console.error("Fetch summary error", e);
                this.transactions = [];
            }
        },

        //  FILTERED DATA
        get filteredTransactions() {
            if (!this.search) return this.transactions;

            return this.transactions.filter(item =>
                (item.customer_company || '')
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
            );
        },

        //  HITUNG ULANG TOTAL BERDASARKAN FILTER
        calculateTotal() {
            this.totalPiutang = this.transactions.reduce(
                (acc, curr) => acc + Number(curr.sisa_tagihan || 0),
                0
            );
        },

        // optional: kalau mau total ikut filter
        get filteredTotal() {
            return this.filteredTransactions.reduce(
                (acc, curr) => acc + Number(curr.sisa_tagihan || 0),
                0
            );
        },

        toggleDetail(id) {
            this.activeId = this.activeId === id ? null : id;
        },

        formatRupiah(n) {
            return new Intl.NumberFormat('id-ID', {
                style: 'currency',
                currency: 'IDR',
                minimumFractionDigits: 0
            }).format(n ?? 0);
        },

        getInitials(name) {
            if (!name) return '??';
            return name
                .split(' ')
                .filter(v => v)
                .map(n => n[0])
                .join('')
                .toUpperCase()
                .substring(0, 2);
        }
    }
}

window.followUpWhatsApp = function (notaId, event) {
    const btn = event.currentTarget || event.target.closest('button');
    if (!btn) return;

    const originalContent = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span class="animate-pulse">Loading...</span>';

    fetch(`/pelaporan/get-summary-nota/${notaId}`)
        .then(response => {
            if (!response.ok) throw new Error('Gagal mengambil data');
            return response.json();
        })
        .then(result => {
            if (result.success) {
                const data = result.data;
                let paymentHistoryText = "";
                try {
                    if (data.payment_history) {
                    try {
                        const history = typeof data.payment_history === 'string'
                            ? JSON.parse(data.payment_history)
                            : data.payment_history;

                        if (Array.isArray(history) && history.length > 0) {
                            paymentHistoryText = "\n*Riwayat Pembayaran:*\n";

                            history.forEach((pay) => {
                                const cleanAmount = Number(pay.amount || 0);
                                const amountFormatted = new Intl.NumberFormat('id-ID').format(cleanAmount);
                                const dateObj = new Date(pay.date);
                                let dateFormatted = "Tgl tidak valid";

                                if (!isNaN(dateObj.getTime())) {
                                    dateFormatted = dateObj.toLocaleDateString('id-ID', {
                                        day: '2-digit',
                                        month: 'short',
                                        year: 'numeric'
                                    });
                                }

                                if (cleanAmount > 0) {
                                    paymentHistoryText += `✅ ${dateFormatted} — Rp ${amountFormatted}\n`;
                                }
                            });
                        }
                    } catch (e) {
                        console.error("Gagal memproses riwayat pembayaran:", e);
                    }
                }
                } catch (e) {
                    console.error("Gagal parse riwayat pembayaran", e);
                }

                let phone = (data.company_phone || '').replace(/\D/g, '');
                const invoiceUrl = `${window.location.origin}/api/pelaporan/get-invoice-nota/${data.encrypted_nota_id}`;
                if (phone.startsWith('0')) phone = '62' + phone.slice(1);
                else if (phone.startsWith('8')) phone = '62' + phone;
                const message = `Yth. Bapak/Ibu *${data.customer_company}*,

                Dengan Hormat,
                Dalam hal ini kami selaku Tim Finance *${data.company_name}*, izin menyampaikan informasi mengenai status tagihan yang belum terselesaikan dengan rincian sebagai berikut:

                ------------------------------------------
                📄 *DETAIL NOTA*
                ------------------------------------------
                Nomor Nota: *${data.nota_code}*
                Status: _${data.status_realtime}_

                💰 *RINCIAN PEMBAYARAN*
                Total Tagihan: Rp ${new Intl.NumberFormat('id-ID').format(data.grand_total)}
                Total Terbayar: Rp ${new Intl.NumberFormat('id-ID').format(data.total_terbayar)}
                ------------------------------------------
                🚨 *SISA TAGIHAN:* *Rp ${new Intl.NumberFormat('id-ID').format(data.sisa_tagihan)}*
                ------------------------------------------

                📌 Riwayat Pembayaran:
                ${paymentHistoryText}

                📑 *INVOICE*
                Untuk melihat invoice lengkap, silakan klik link berikut:
                ${invoiceUrl}

                Demikian kami sampaikan, kami berharap kerjasama Bapak/Ibu untuk segera melakukan penyelesaian pembayaran sesuai dengan kesepakatan. Pembayaran dapat dilakukan melalui Bank Transfer ke BANK BCA No. Rekening ${data.account_number} / ${data.company_name}. Jika Bapak/Ibu telah melakukan pembayaran, silahkan mengirimkan bukti pembayarannya kepada kami untuk kami cek dan segera kami proses untuk rekonsiliasi.

                Terima kasih atas perhatian dan kerjasamanya.

                Hormat kami,
                *${data.PIC_name}*

                *${data.company_name}*`;

                const waUrl = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
                window.open(waUrl, '_blank');

            } else {
                alert('Data tidak ditemukan: ' + result.message);
            }
        })
        .catch(error => {
            console.error('Error:', error);
            alert('Terjadi kesalahan saat menghubungi server.');
        })
        .finally(() => {
            btn.disabled = false;
            btn.innerHTML = originalContent;
        });
}

window.exportToExcel = function () {

    const startDate = document.getElementById('start_date')?.value;
    const endDate   = document.getElementById('end_date')?.value;

    if (!startDate || !endDate) {
        alert('Rentang tanggal wajib diisi');
        return;
    }

    let url = `/pelaporan/get-summary-nota-excell?start_date=${startDate}&end_date=${endDate}`;

    window.open(url, '_blank');
};
